import classNames from 'classnames';
import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';

interface CarrouselProps extends PropsWithChildren{
	align?: 'start' | 'end' | 'center',
	maxWidth?: number,
	title?: React.ReactNode,
	titlePlaceholder?: boolean,
	navigation?: boolean,
	action?: any,
}

var Carrousel = (props: CarrouselProps)=>{
	var scrollRef = useRef<HTMLDivElement>(null);
	var [canLeft, setCanLeft] = useState(false);
	var [canRight, setCanRight] = useState(true);

	var updateArrows = ()=>{
		if(!scrollRef.current) return;
		var el = scrollRef.current;
		setCanLeft(el.scrollLeft > 5);
		setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
	};

	useEffect(()=>{
		updateArrows();
		var el = scrollRef.current;
		if(!el) return;
		var observer = new ResizeObserver(updateArrows);
		observer.observe(el);
		return ()=> observer.disconnect();
	}, []);

	var scrollBy = (dir: number)=>{
		if(!scrollRef.current) return;
		var el = scrollRef.current;
		var cardWidth = el.querySelector('.co.product')?.clientWidth || el.clientWidth / 3;
		el.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
	};
	
	return <div className='fr carrousel'>
		{(!!props.title || !!props.navigation) && (
			<div className="header">
				<div className={classNames("text", {
					placeholder: props.titlePlaceholder,
				})}>{props.title}</div>
				{!!props.action && (
					<div className="action">
						{props.action}
					</div>
				)}
			</div>
		)}
		<div className="scroll-wrapper">
			<button className={classNames("scroll-arrow left", { disabled: !canLeft })} onClick={()=>scrollBy(-1)} aria-label="Anterior">
				<i className="arrow left icon"></i>
			</button>
			<div ref={scrollRef} className="scroll" onScroll={updateArrows}>
				{props.children}
			</div>
			<button className={classNames("scroll-arrow right", { disabled: !canRight })} onClick={()=>scrollBy(1)} aria-label="Siguiente">
				<i className="arrow right icon"></i>
			</button>
		</div>
	</div>
}

export default Carrousel;